const administrator = {
	tabs: {
		manage_permissions: "Rechten beheren",
		user_activate: "Activatie account",
		user_create_new: "Nieuwe gebruiker toevoegen",
		user_management: "Gebruikers beheren",
	},
	title: "Administrator",
	user_management: {
		active: {
			block_modal: {
				description: "Weet u zeker dat u <strong>{{username}}</strong> wilt blokkeren?",
				status: {
					success: "Gebruiker <strong>{{username}}</strong> is succesvol geblokkeerd!",
					unknown:
						"Gebruiker <strong>{{username}}</strong> kan op dit moment niet worden geblokkeerd. Probeer het nogmaals of neem contact op met onze support afdeling.",
				},
				title: "Gebruiker blokkeren",
			},
			button_add_user: "Gebruiker toevoegen",
			deblock_modal: {
				description: "Weet u zeker dat u <strong>{{username}}</strong> wilt deblokkeren?",
				status: {
					success: "Gebruiker <strong>{{username}}</strong> is succesvol gedeblokkeerd!",
					unknown:
						"Gebruiker <strong>{{username}}</strong> kan op dit moment niet worden gedeblokkeerd. Probeer het nogmaals of neem contact op met onze support afdeling.",
				},
				title: "Gebruiker deblokkeren",
			},
			delete_modal: {
				description: "Weet u zeker dat u <strong>{{username}}</strong> wilt verwijderen?",
				status: {
					success: "Gebruiker <strong>{{username}}</strong> is succesvol verwijderd!",
					unknown:
						"Gebruiker <strong>{{username}}</strong> kan op dit moment niet verwijderd worden. Probeer het nogmaals of neem contact op met onze support afdeling.",
				},
				title: "Gebruiker verwijderen",
			},
			description:
				"Hier bevinden zich de gebruikers die aangemeld zijn op het portaal. Hier kunnen er gebruikers toegevoegd, gewijzigd en verwijderd worden.",
			title: "Actieve gebruikers",
		},
		add_user_first: {
			description:
				"Gebruik daarna alleen nog maar dit nieuwe account om in te loggen. Maak daarna, via uw nieuwe account, accounts aan voor eventuele collega's en geef ze de juiste rechten.",
			title:
				"U kunt deze pagina momenteel niet verlaten. U dient eerst een persoonlijk account (gebruiker) aan te maken.",
		},
		categories: {
			action: {
				update: "Labels updaten",
			},
			description:
				"Selecteer hier het label of de labels die u aan een gebruiker wilt toewijzen. Labels zijn puur visueel; ze worden gebruikt om de functie of taak aan te duiden die een gebruiker binnen uw bedrijf vervult.",
			placeholder: "Selecteer label(s)",
			status: { success: "Labels succesvol gekoppeld aan de gebruiker" },
			title: "Selecteer labels",
		},
		create: {
			sign_in_details: {
				description: "Voer hier het e-mailadres en de gebruikersnaam in voor de nieuwe gebruiker.",
				title: "Inloggegevens invoeren",
			},
			status: {
				email_address_invalid:
					"Het door uw ingevoerde e-mailadres is onjuist. Gebruik een geldig e-mailadres.",
				invalid:
					"Uw verzoek om een nieuwe gebruiker toe te voegen is afgewezen, probeer het nogmaals of neem contact op met onze support afdeling.",
				success:
					"Nieuwe gebruiker is succesvol toegevoegd. Een uitnodiging is gestuurd naar het volgende e-mailadres:",
				unknown:
					"Er is iets misgegaan tijdens het toevoegen van een nieuwe gebruiker, probeer het nogmaals of neem contact op op met onze support afdeling.",
				username_in_use: "De door u ingevoerde gebruikersnaam is al in gebruik.",
			},
			user_details: {
				description:
					"Voer hier de accountgegevens in voor de nieuwe gebruiker, de gebruiker kan dit na de registratie zelf aanpassen.",
				title: "Accountgegevens invoeren",
			},
		},

		/* --------------------------------- INVITE --------------------------------- */
		invite: {
			button: "Snel Gebruiker toevoegen",
			description:
				"Hier bevinden zich de bekende contacten die gevonden zijn, maar nog geen portal account hebben. U kan makkelijk een account voor ze aanmaken door op de snel aanmaken knop te drukken.",
			empty_table: "Er zijn geen bekende contacten gevonden.",
			title: "Bekende contacten zonder portal account",
		},
		pending: {
			delete_modal: {
				description:
					"Weet u zeker dat u de uitnodiging wil intrekken voor gebruiker <strong>{{username}}</strong>?",
				status: {
					success:
						"Uitnodiging succesvol ingetrokken voor gebruiker <strong>{{username}}</strong>!",
					unknown:
						"De uitnodiging van gebruiker <strong>{{username}}</strong> kan op dit moment niet worden ingetrokken. Probeer het nogmaals of neem contact op met onze support afdeling.",
				},
				title: "Uitnodiging annuleren",
			},
			description:
				"Hier bevinden zich de gebruikers die zijn uitgenodigd, maar de uitnodiging nog niet geaccepteerd hebben. Binnen deze sectie kunnen uitnodigingen geannuleerd en opnieuw verstuurd worden.",
			empty_table: "Er zijn geen openstaande uitnodigingen aangetroffen.",
			resend_modal: {
				description:
					"Weet u zeker dat u gebruiker <strong>{{username}}</strong> een nieuwe uitnodiging wilt sturen?",
				status: {
					success: "Uitnodiging succesvol opnieuw verstuurd naar <strong>{{username}}</strong>!",
					unknown:
						"Er kan op dit moment geen nieuwe uitnodiging verstuurd worden naar gebruiker <strong>{{username}}</strong>. Probeer het nogmaals of neem contact op met onze support afdeling.",
				},
				title: "Uitnodiging opnieuw versturen",
			},
			title: "Gebruikers in afwachting",
		},
		permissions: {
			assign: {
				active:
					"Het wijzigen van de rechten is van toepassing voor gebruiker <strong>{{username}}</strong>.",
				"allow-all": "Alles toestaan",
				description: `In deze sectie kunnen de rechten voor de gebruiker worden toegewezen. De permissies zijn gegroepeerd per categorie, elke categorie kan worden uitgeklapt door er op te klikken. 
					De rechten zijn te allen tijde alleen van toepassing op de debiteuren waar deze gebruiker aan gekoppeld is.`,
				title: "Rechten toekennen aan de gebruiker.",
			},
			categories: {
				admin: "Admin rechten",
				company: "Bedrijfsrechten",
			},
			clone: {
				description:
					"Door de rechten van een andere gebruiker over te nemen, kunt u gemakkelijk rechten toekennen aan de nieuwe gebruiker.",
				placeholder: "Neem gebruikersrechten over",
				title: "Kopieer gebruikersrechten",
			},
			description: "Hier kunt u de rechten van de gebruiker beheren.",
			permission_titles: {
				admin: {
					user_create: "Gebruikers aanmaken",
					user_delete: "Gebruikers verwijderen",
					user_read: "Gebruikers inzien",
					user_update: "Gebruikers bewerken",
				},
				company: {
					billing_invoices_read: "Facturen inzien",
					billing_orders_read: "Orders inzien",
					details_read: "Details inzien",
					details_update: "Details bewerken",
				},
			},
			title: "Rechten beheren gebruiker",
		},
		update: {
			success: "De rechten zijn succesvol bijgewerkt.",
		},
	},
};

export default administrator;
